import { ProductCardProps } from "@/components/ProductCard";
import { SEGMENTOS_POS } from "@/api/products";
import { formatPrice } from "@/utils/currency";
import Text from "@/components/Text";
import Price from "@/components/Price";
import Button from "@/components/Button";
import CompositionPlan from "@/components/CompostionPlan";
import AppBenefits from "@/components/AppBenefits";
import { useEffect, useState } from "react";
import { removeAccentAndSpaceAndSetLowerCase } from "@/utils/string";

export default function Header({ product, onSelect, to }: ProductCardProps) {
  const ddd = import.meta.env.VITE_DDD_DEFAULT_PLANS;
  const price = product.precos.find((p) => p.ddd === ddd);

  const [sendDataLayer, setSendDataLayer] = useState(false);

  const isPos = SEGMENTOS_POS.includes(product.segmento);
  const actualPriceFormatted = formatPrice(price?.preco_atual || 0);
  const actualPrice = price?.preco_atual || 0;

  const fidelity = product.fidelidades?.find((f) =>
    f.precos.some((p) => p.ddd === ddd)
  );
  const fidelityPrice = product.fidelidades
    ?.find((f) => f.precos.some((p) => p.ddd === ddd))
    ?.precos.find((p) => p.ddd === ddd)?.preco_atual;

  const actualFidelityPrice =
    Math.round((actualPrice + (fidelityPrice || 0)) * 100) / 100;

  useEffect(() => {
    if (sendDataLayer) return;

    window?.dataLayer?.push({
      dataLayerName: "omegaDataLayer",
      dataLayer: {
        ecommerce: {
          event: "view_item_list",
          currency: "BRL",
          items: [
            {
              item_name: removeAccentAndSpaceAndSetLowerCase(product.nome),
              item_id: product.tim_id,
              price: formatPrice(actualFidelityPrice),
              item_variant: isPos ? "Plano TIM Black" : "Plano TIM Controle",
              quantity: 1,
            },
          ],
        },
      },
    });
    setSendDataLayer(true);
  }, [actualFidelityPrice, product, sendDataLayer, isPos]);
  return (
    <>
      <div className="flex items-center justify-between text-tim-primary">
        <section>
          <Text
            as="h2"
            size="5xl"
            className="font-semibold uppercase leading-none tracking-wide"
          >
            {product.gb}GB
          </Text>
        </section>

        <section>
          <div className="text-center text-sm text-gray-400 ">
            {actualFidelityPrice < actualPrice && (
              <>
                <span className="line-through">
                  de R$ {actualPriceFormatted}
                </span>{" "}
                por
              </>
            )}
          </div>

          <div className="items-center text-center font-medium leading-none">
            <Price price={actualFidelityPrice || actualPrice} />
          </div>
        </section>
        <section>
          <Button to={to} onClick={() => onSelect?.(product)}>
            CONTRATAR AGORA
          </Button>
          <div className="px-3 pt-1 text-center text-xs text-gray-400">
            {fidelity && (fidelity.descricao_omega ?? fidelity.descricao)}
          </div>
        </section>
      </div>
      <div className="flex flex-1 flex-col pt-1">
        <section className="flex flex-row items-center justify-between pb-1 pt-6">
          <CompositionPlan
            showTitle={false}
            gbPadrao={product.gbPadrao}
            gbPromocional={product.gbPromocional}
            gbBonusPortabilidade={product.gbBonusPortabilidade}
            mostrarPortabilidade={product?.mostrarPortabilidade}
            gbBonusDedicado={product?.gbBonusDedicated}
            mostrarDedicado={product?.mostrarDedicado}
            isPos={isPos}
          />
          <AppBenefits benefits={product.beneficios} />
        </section>
      </div>
    </>
  );
}
